import React from "react";
import LoadingLottieAnimation from "../../../../../../components/app-specific/lottie-animations/loading";
import ManageProductDimensions from "../../../../../../components/app-specific/manage-product-dimensions";


const ProductInformationDimensionsView = ({loading, partNo, partId,}) => {

    return (
        <>
            <div className={'w-100 part-info-paper d-flex flex-column p-3'}>
                {
                    loading &&
                    <>
                        <div className='my-2 w-100'/>
                        <LoadingLottieAnimation className={''} width={'80%'}/>
                        <div className='my-2 w-100'/>
                    </>
                }
                {
                    !loading &&
                    <ManageProductDimensions
                        partId={partId}
                        partNo={partNo}
                        title={"Manage Product Dimensions"}
                    />
                }
            </div>
        </>
    )
}

export default ProductInformationDimensionsView;


